import { getConfigInfo } from '@/utils'
const item = getConfigInfo()
const subName = item ? item.subName : '系统'

export const finance = {
  feeType: [{
    value: 1, label: '保单奖励'
  }, {
    value: 2, label: '区域奖励费'
  }, {
    value: 4, label: '跟单手续费'
  }, {
    value: 5, label: '其他奖励'
  }, {
    value: 8, label: '保单、区域奖励费'
  }, {
    value: 9, label: '跟单、其他、区域奖励费'
  }, {
    value: 10, label: '跟单、其他奖励'
  }, {
    value: 11, label: '跟单、区域奖励费'
  }, {
    value: 12, label: '其他、区域奖励费'
  }],
  rewardFeeType: [{
    value: 13, label: '负责人奖励费用'
  }],
  settleDateType: [{
    value: 1, label: '操作时间'
  }, {
    value: 2, label: '结算周期起'
  }, {
    value: 3, label: '结算周期止'
  }],
  settlePayStatus: [{
    value: 1, label: '打款中'
  }, {
    value: 2, label: '打款成功'
  }, {
    value: 3, label: '部分打款'
  }, {
    value: 4, label: '打款失败'
  }],
  balanceMode: [{
    value: 1, label: '线下打款'
  }, {
    value: 2, label: '第三方系统', hidden: true
    // }, {
    //   value: 3, label: '众包结算'
  }, {
    value: 4, label: '银企直连'
  }, {
    value: 5, label: '虚拟账户'
  }, {
    value: 6, label: '推广打款'
  }, {
    value: 7, label: '微信打款'
  }],
  payUserType: [{
    value: 0, label: '业务员'
  }, {
    value: 1, label: '收款人'
  }],
  settlePriceType: [{
    value: 1, label: '保单奖励'
  }, {
    value: 2, label: '区域奖励费'
  }, {
    value: 4, label: '跟单手续费'
  }, {
    value: 5, label: '其他奖励'
  }],
  receivablesStatus: [{
    value: 1, label: '未收款'
  }, {
    value: 2, label: '部分收款'
  }, {
    value: 3, label: '已收款'
  }, {
    value: 4, label: '超额收款'
  }],
  invoiceStatus: [{
    value: 1, label: '未开票'
  }, {
    value: 2, label: '部分开票'
  }, {
    value: 3, label: '已开票'
  }, {
    value: 4, label: '超额开票'
  }],
  settleStatus: [{
    value: 0, label: '对账存在问题'
  }, {
    value: 1, label: '结算成功'
  }, {
    value: 2, label: '已撤销'
  }, {
    value: 3, label: '部分成功'
  }],
  auditStatus: [{
    value: 0, label: '待审批'
  }, {
    value: 1, label: '审批通过'
  }, {
    value: 4, label: '审批拒绝'
  }],
  settleType: [{
    value: 1, label: '上游'
  }, {
    value: 2, label: '下游'
  }, {
    value: 3, label: '下游'
  }, {
    value: 4, label: '奖励'
  }],
  settlePriceStatus: [{
    value: 1, label: '结算成功'
  }, {
    value: 2, label: '结算失败'
  }, {
    value: 3, label: '部分结算'
  }, {
    value: 4, label: '未结算'
  }, {
    value: 6, label: '结算中'
  }, {
    value: 5, label: '结算成功'
  }],
  exSettlePriceStatus: [{
    value: 0, label: '待审批'
  }, {
    value: 1, label: '待打款'
  }, {
    value: 2, label: '打款中'
  }, {
    value: 3, label: '打款成功'
  }, {
    value: 4, label: '打款失败'
  }, {
    value: 5, label: '部分打款'
  }, {
    value: 6, label: '已拒绝'
  }],
  isDocumentary: [{ // 政策类型
    value: 1, label: '跟单'
  }, {
    value: 0, label: '基础'
  }],
  settlementDateType: [{ // 日期类型
    value: 1, label: '上游结算日期'
  }, {
    value: 2, label: '下游结算日期'
  }, {
    value: 3, label: '上下游结算日期'
  }],
  waitPayDateType: [{
    value: 1,
    label: '签单日期'
  }, {
    value: 8,
    label: '支付日期'
  }, {
    value: 10,
    label: `录入${subName}日期`
  }],
  financePolicyPersonnel: [{ // 保单业务归属人员
    value: 0, label: '业务员'
  }, {
    value: 1, label: '出单员'
  }, {
    value: 2, label: '录单员'
  }, {
    value: 3, label: '工号'
  }],
  financeStatus: [{ // 保单设置状态
    value: 0, label: '禁用'
  }, {
    value: 1, label: '启用'
  }],
  financeReverseStatus: [{ // 保单设置状态
    value: 1, label: '禁用'
  }, {
    value: 0, label: '启用'
  }],
  syncPattern: [{ // 限制不支持同步的保单的录单模式
    value: 0, label: '手工录单'
  }, {
    value: 1, label: '自动录单'
  }, {
    value: 8, label: '批量自动录单'
  }, {
    value: 11, label: '打印页自动录单'
  }, {
    value: 14, label: 'PC端报价'
  }, {
    value: 15, label: '列表批量获取'
  }, {
    value: 18, label: '微信小程序自动落单'
  }, {
    value: 19, label: 'H5自动落单'
  }, {
    value: 21, label: 'APP自动落单'
  }],
  hasInvoiceNo: [{
    value: 0, label: '否'
  }, {
    value: 1, label: '是'
  }],
  accountType: [{
    value: 1, label: '上游'
  }, {
    value: 2, label: '下游'
  }],
  settleInsuranceType: [{ // 结算业务
    value: 1, label: '车险业务'
  }, {
    value: 2, label: '非车业务'
  }],
  JZFUserStatus: [{
    value: 0, label: '禁用'
  }, {
    value: 1, label: '启用'
  }],
  JZFUserRoleInfo: [{
    value: 'admin', label: '系统管理员'
  }, {
    value: 'master', label: '会计主管'
  }, {
    value: 'bookkeeper', label: '记账会计'
  }, {
    value: 'taxaccounting', label: '报税会计'
  }, {
    value: 'assistant', label: '助理会计'
  }, {
    value: 'outaccounting', label: '外勤会计'
  }],
  downstreamQueryDateType: [{
    value: 3, label: '操作时间'
  }, {
    value: 4, label: '入账时间'
  }],
  downstreamIsRelate: [{
    value: 0, label: '否'
  }, {
    value: 1, label: '是'
  }],
  remitdata: [{
    value: 0, label: '人工打款'
  }, {
    value: 1, label: '自动打款'
  }],
  taxRateType: [{
    value: '1', label: '小规模纳税人'
  }, {
    value: '2', label: '一般纳税人'
  }],
  visualizationType: [{
    value: 1, label: '开票'
  }, {
    value: 2, label: '提成薪酬'
  }, {
    value: 3, label: '佣金支出'
  }, {
    value: 4, label: '费用报销'
  }, {
    value: 5, label: '资金调拨'
  }, {
    value: 6, label: '手工维护'
  }],
  visualizationOperateType: [{
    value: 1, label: '收入确认'
  }, {
    value: 2, label: '收入撤销'
  }, {
    value: 3, label: '冻结'
  }, {
    value: 4, label: '解冻'
  }, {
    value: 5, label: '支出确认'
  }, {
    value: 6, label: '支出撤销'
  }, {
    value: 7, label: '调整预算'
  }, {
    value: 8, label: '历史数据迁移'
  }],
  sceneTypeList: [{ // 模版类型:sceneType 1-系统2-自定义
    value: 1, label: '系统'
  }, {
    value: 2, label: '自定义'
  }],
  financePolicyType: [{
    label: '仅组织', value: 2
  }, {
    label: '优先人员', value: 1
  }]
}

export const convert = {
  // 合作伙伴（财务对接）
  cooperation: [{
    value: 59, label: '畅捷通', logo: '//h.chanjet.com/static/v4/images/common/logo.png'
  }]
}

export default {
  finance,
  convert
}



// WEBPACK FOOTER //
// ./src/data/finance.js